import { Spinner } from "@/components/ui/spinner";
import { useAuth } from "@clerk/react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Pin } from "@/components/ui/pin";
import { useAutopilotStore, useCreatorsStore } from "@/stores";
import { Creator } from "@/types/types";

interface AutopilotToggleProps {
  creator_id: string;
}

export default function AutopilotToggle({ creator_id }: AutopilotToggleProps) {
  const { getToken } = useAuth();
  const { creators, setCreators } = useCreatorsStore();
  const { toggleThreadAutopilot, isAutopilotLoading } = useAutopilotStore();

  const currentCreator = creators.find((c) => c._id === creator_id);
  const isAutopilot = currentCreator?.autopilot ?? false;

  const handleToggle = async () => {
    const token = await getToken();
    if (!token) return;

    const success = await toggleThreadAutopilot(creator_id, !isAutopilot, token);
    if (success) {
      const updatedCreators = creators.map((creator: Creator) =>
        creator._id === creator_id
          ? { ...creator, autopilot: !isAutopilot }
          : creator
      );
      setCreators(updatedCreators);
    }
  };

  return (
    <Tooltip delayDuration={1000}>
      <TooltipTrigger asChild>
        <Button
          onClick={handleToggle}
          className="h-7 px-1.5"
          variant="ghost"
          disabled={isAutopilotLoading}
          size="sm"
        >
          {!isAutopilotLoading && (
            <Pin
              className="ml-2 size-2.25"
              variant={isAutopilot ? "success" : "destructive"}
            />
          )}
          {isAutopilotLoading && <Spinner className="ml-1" />}
          <Label
            htmlFor="autopilot-switch"
            className="text-xs font-medium cursor-pointer text-foreground ml-1"
          >
            Autopilot
          </Label>
          <Switch
            id="autopilot-switch"
            size="sm"
            checked={isAutopilot}
            disabled={isAutopilotLoading}
          />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p className="text-center max-w-56">
          Autopilot-On, means Amy automatically replies and follows up with this
          creator.
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
